import React from "react";
import { Checkbox, Divider, Row, Col } from "antd";

const CheckboxGroup = Checkbox.Group;

const RadioGroup = ({ label, list, checkedList, setCheckedList }) => {
  const groupSlugs = list.map((x) => x.slug);
  const groupChecked = checkedList.filter((item) =>
    groupSlugs.includes(item)
  );

  const onGroupChange = (checkedValues) => {
    const rest = checkedList.filter((item) => !groupSlugs.includes(item));
    setCheckedList([...rest, ...checkedValues]);
  };

  const onCheckAllChange = (e) => {
    const checked = e.target.checked;
    const rest = checkedList.filter((item) => !groupSlugs.includes(item));
    setCheckedList(checked ? [...rest, ...groupSlugs] : rest);
  };

  const isIndeterminate =
    groupChecked.length > 0 && groupChecked.length < groupSlugs.length;
  const isCheckAll = groupChecked.length === groupSlugs.length;

  return (
    <>
      <Checkbox
        indeterminate={isIndeterminate}
        onChange={onCheckAllChange}
        checked={isCheckAll}
      >
        {label}
      </Checkbox>
      <Divider />
      <CheckboxGroup
        value={groupChecked}
        onChange={onGroupChange}
      >
        <Row gutter={[8, 8]}>
          {list.map((x) => (
            <Col key={x.slug} span={8}>
              <Checkbox value={x.slug}>{x.name}</Checkbox>
            </Col>
          ))}
        </Row>
      </CheckboxGroup>
    </>
  );
};

export default RadioGroup;
